import React from 'react';
import ReactDOM from 'react-dom/client';
import { installAltcha, mountAltcha } from '@msa/altcha';
import { Router } from 'react-router';
import { Provider } from 'react-redux';
import moment from 'moment';
import App from './App';
import { history } from './core/history';
import { store } from './core/Store';
import * as AppManager from './reducers/ui/app';
import * as DictionariesDataManager from './reducers/data/dictionaries';

import './index.css';
import '@msa/altcha/Altcha.css';

Object.assign(window, {
	store,
	moment,
});

installAltcha();

mountAltcha(document.body);

export const loadAppResources = () => {
	AppManager.initBodyScrollTracker();
	AppManager.initViewportWidthTracker();
	Promise.all([DictionariesDataManager.loadAllDictionaries()]).then(() => {
		console.log('app resources loaded');
		store.dispatch(AppManager.Actions.setAppLoaded(true));
	});
};

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<>
		<Router history={history}>
			<Provider store={store}>
				<App />
			</Provider>
		</Router>
	</>
);
